import api from '@utils/api';

export const getApartments = async (page = 1, perPage = 10) => {
  try {
    const response = await api.get('/apartments', {
      params: {
        page,
        per_page: perPage,
      },
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching apartments:', error);
    throw error;
  }
};

export const getMyApartment = async () => {
  try {
    const response = await api.get('/apartment-users/by-current-user');
    return response.data;
  } catch (error) {
    console.error('Error fetching apartment for current user:', error);
    throw error;
  }
};

export const getApartmentById = async (apartmentId) => {
  try {
    const response = await api.get(`/apartments/${apartmentId}`);
    return response.data;
  } catch (error) {
    console.error(`Error fetching apartment ${apartmentId}:`, error);
    throw error;
  }
};

export const getApartmentsByPlace = async (placeId, page = 1, perPage = 10) => {
  try {
    const response = await api.get(`/apartments/place/${placeId}`, {
      params: {
        page,
        page_size: perPage,
        sort_by: 'created_at',
        sort_order: 'desc',
      },
    });
    return response.data;
  } catch (error) {
    console.error(`Error fetching apartments for place ${placeId}:`, error);
    throw error;
  }
};

export const getUsersByApartment = async (apartmentId) => {
  try {
    const response = await api.get(`/apartment-users/apartment/${apartmentId}`);
    return response.data;
  } catch (error) {
    console.error(`Error fetching users for apartment ${apartmentId}:`, error);
    throw error;
  }
};

export const createApartment = async (apartmentData) => {
  try {
    const response = await api.post('/apartments', apartmentData);
    return response.data;
  } catch (error) {
    console.error('Error creating apartment:', error);
    throw error;
  }
};

export const updateApartment = async (id, apartmentData) => {
  try {
    const response = await api.put(`/apartments/${id}`, apartmentData);
    return response.data;
  } catch (error) {
    console.error(`Error updating apartment ${id}:`, error);
    throw error;
  }
};

export const deleteApartment = async (id) => {
  try {
    const response = await api.delete(`/apartments/${id}`);
    return response.data;
  } catch (error) {
    console.error(`Error deleting apartment ${id}:`, error);
    throw error;
  }
};

export const deleteUserFromApartment = async (associationId) => {
  try {
    const response = await api.delete(`/apartment-users/${associationId}`);
    return response.data;
  } catch (error) {
    console.error(`Error deleting user association ${associationId}:`, error);
    throw error;
  }
};

export const assignUserToApartment = async (apartmentId, userId) => {
  try {
    const response = await api.post("/apartment-users", {
      apartment_id: apartmentId,
      user_id: userId,
    });
    return response.data;
  } catch (error) {
    console.error(`Error assigning user ${userId} to apartment ${apartmentId}:`, error);
    throw error;
  }
};
